<template>
  <div class="mt-8 grid grid-cols-1 md:grid-cols-2 md:gap-5" v-if="fondsStore.selectedFonds">
    <div class="w-full" :class="[fondsStore.notTradable ? 'opacity-40' : '']">
      <BarChart></BarChart>
    </div>
    <div class="w-full" :class="[fondsStore.notTradable ? 'opacity-40' : '']">
      <LineChart></LineChart>
    </div>
  </div>
</template>

<script setup lang="ts">
import BarChart from './BarChart.vue'
import LineChart from './LineChart.vue'
import { useFondsStore } from '@/stores/fonds'
const fondsStore = useFondsStore()
</script>
